import { POST, DELETE } from './API';

const PATH_ROOT = 'U006';

export type A01Input = {
  user_id: string;
};
export type A01Output = {
  user_id: string;
  firstname: string;
  lastname: string;
  firstname_kana: string;
  lastname_kana: string;
  birth: string;
  mfa: string;
  notification: string;
  phone1: string;
  mail: string;
  term_of_service_consent: string;
  privacy_notice_consent: string;
  specific_use_consent: string;
  parental_consent?: string;
  consent_form?: string;
  line_id?: string;
  line_nonce?: string;
  applicant_revision: number;
  user_info_revision: number;
};

export async function A01(input: A01Input, cancellation?: AbortSignal): Promise<A01Output> {
  return await POST(`${PATH_ROOT}/get_user`, {
    user_id: input.user_id,
    signal: cancellation,
  });
}

export type A02Input = {
  user_id: string;
  firstname: string;
  lastname: string;
  firstname_kana: string;
  lastname_kana: string;
  birth: string;
  mfa: string;
  notification: string;
  phone1: string;
  mail: string;
  revision: number;
};
export type A02Output = {
  status: string;
  msgid: string;
  count: number;
};
export async function A02(input: A02Input, cancellation?: AbortSignal): Promise<A02Output> {
  return await POST(`${PATH_ROOT}/update_user`, {
    user_id: input.user_id,
    firstname: input.firstname,
    lastname: input.lastname,
    firstname_kana: input.firstname_kana,
    lastname_kana: input.lastname_kana,
    birth: input.birth,
    mfa: input.mfa,
    notification: input.notification,
    phone1: input.phone1,
    mail: input.mail,
    revision: input.revision,
    signal: cancellation,
  });
}

export type A03Input = {
  user_id: string;
  applicant_revision: number;
  user_info_revision: number;
};
export type A03Output = {
  status: string;
  msgid: string;
  audition_info?: {
    audition_id: string;
    title: string;
  }[];
};
export async function A03(input: A03Input, cancellation?: AbortSignal): Promise<A03Output> {
  return await DELETE(`${PATH_ROOT}/user`, {
    user_id: input.user_id,
    applicant_revision: input.applicant_revision,
    user_info_revision: input.user_info_revision,
    signal: cancellation,
  });
}
